module.exports = __webpack_public_path__ + "static/media/efix_logo.0da18346.svg";